import React, { useState, useEffect } from 'react';
import { ConstructorEventUpdateSQLStatus } from '../../../../Event/event';

const NumberRiddleRooms = () => {
  const [riddle, setRiddle] = useState({});
  const [answer, setAnswer] = useState('');
  const [feedback, setFeedback] = useState('');
  const [hintVisible, setHintVisible] = useState(false);
  const [hint, setHint] = useState('');
  const [stars, setStars] = useState(0);
  const [doorOpen, setDoorOpen] = useState(false);
  const [keyVisible, setKeyVisible] = useState(false);
  const [numberVisible, setNumberVisible] = useState(false);

  const riddles = [
  {
    clue: "I'm a 2-digit number. My digits add up to 6. I'm double of 18.",
    answer: 36,
    hint: "Think of the double of 18."
  },
  {
    clue: "I'm an odd number. I’m greater than 40 but less than 50. My digits add up to 11.",
    answer: 47,
    hint: "Try adding digits of numbers between 40 and 50."
  },
  {
    clue: "I'm a multiple of 9. My digits add up to 9.",
    answer: 9,
    hint: "All multiples of 9 have digit sums that are also multiples of 9."
  },
  {
    clue: "I'm a 2-digit number. If you multiply me by 3, you get 60.",
    answer: 20,
    hint: "Think 3 × ? = 60."
  },
  {
    clue: "I'm less than 50. My digits multiply to 8. I’m even.",
    answer: 24,
    hint: "Try 2 × 4 = 8."
  },
  {
    clue: "I’m a number between 60 and 70. My digits add up to 13.",
    answer: 67,
    hint: "Add digits of numbers between 60–70 until you get 13."
  },
  {
    clue: "If you divide me by 5, you get 8. I'm a multiple of 10.",
    answer: 40,
    hint: "Think 5 × ? = 40."
  },
  {
    clue: "I'm double of 14 and half of 56.",
    answer: 28,
    hint: "Think what’s between 14 and 56."
  },
  {
    clue: "I'm a 2-digit number ending in 5. If you multiply me by 2, the result ends in 0.",
    answer: 25,
    hint: "5 × 2 gives 10 — so last digit 5 becomes 0."
  },
  {
    clue: "If you add me to 9, you get 20. I’m even.",
    answer: 11,
    hint: "What number + 9 = 20?"
  }
];

  useEffect(() => {
    loadRiddle();
  }, []);

  const loadRiddle = () => {
    const r = riddles[Math.floor(Math.random() * riddles.length)];
    setRiddle(r);
    setAnswer('');
    setFeedback('');
    setHintVisible(false);
    setHint('');
    setKeyVisible(false);
    setDoorOpen(false);
    setNumberVisible(false);
  };

  const checkAnswer = () => {
    const userAnswer = parseInt(answer);
    if (userAnswer === riddle.answer) {
      setStars(prev => prev + 1);
      setFeedback('✅ Correct! The door is opening...');
      setKeyVisible(true);
      setDoorOpen(true);
      setNumberVisible(true);
      const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
      setTimeout(() => loadRiddle(), 3000);
    } else {
      setFeedback(userAnswer > riddle.answer ? '❌ Too high. Try again.' : '❌ Too low. Try again.');
      if (!hintVisible) {
        setHint('🧠 Hint: ' + riddle.hint);
        setHintVisible(true);
      }
    }
  };

  return (
    <div style={{
      fontFamily: 'Trebuchet MS, sans-serif',
      background: '#121212',
      color: '#fff',
      margin: 0,
      padding: 0,
      overflow: 'hidden',
      height: '100vh',
      width: '100vw'
    }}>
      <div style={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        background: `url('https://cdn.pixabay.com/photo/2016/11/19/13/01/door-1836043_1280.jpg') center/cover no-repeat`,
        position: 'relative'
      }}>
        <div style={{ position: 'absolute', top: 10, right: 10, fontSize: 20, color: 'gold', zIndex: 3 }}>⭐ Score: {stars}</div>

        <div
          style={{
            width: 200,
            height: 300,
            background: '#5c4033',
            border: '5px solid #333',
            borderRadius: 10,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: 18,
            cursor: 'pointer',
            boxShadow: '0 0 10px #000',
            transform: doorOpen ? 'rotateY(120deg)' : 'none',
            transition: 'transform 1s ease-in-out',
            zIndex: 2
          }}
          onClick={checkAnswer}
        >
          Open Door
        </div>

        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          fontSize: 50,
          color: 'gold',
          zIndex: 1,
          transition: 'transform 0.5s ease-in-out',
          transformOrigin: 'center',
          transform: keyVisible ? 'translate(-50%, -50%) scale(1)' : 'translate(-50%, -50%) scale(0)'
        }}>
          🔑
        </div>

        {numberVisible && (
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: 48,
            color: '#fff',
            zIndex: 0,
            opacity: 1,
            transition: 'opacity 0.5s ease-in-out'
          }}>
            {riddle.answer}
          </div>
        )}

        <div style={{
          position: 'absolute',
          bottom: 100,
          background: 'rgba(0, 0, 0, 0.8)',
          padding: 20,
          borderRadius: 10,
          textAlign: 'center',
          zIndex: 3
        }}>
          <div>{riddle.clue}</div>
          <input
            type="number"
            value={answer}
            onChange={e => setAnswer(e.target.value)}
            placeholder="Your answer"
            style={{ padding: 10, fontSize: 16, width: '50%', marginTop: '1%', margin: "0 auto", color: 'black' }}
          />
          <div style={{ marginTop: 10, fontSize: 18, color: '#90ee90' }}>{feedback}</div>
          {hintVisible && (
            <div style={{ marginTop: 10, fontSize: 16, color: '#90ee90' }}>{hint}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NumberRiddleRooms;
